import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { getApps, initializeApp } from 'firebase/app';
import { MessagePayload, deleteToken, getMessaging, getToken, isSupported, onMessage } from 'firebase/messaging';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LayoutUtilsService } from './layout-utils.service';
import { NotificationService } from './notification.service';
import { RequestService } from './request.service';

@Injectable({
  providedIn: 'root'
})
export class FirebaseHandlersService {

  currentMessage = new BehaviorSubject(null);
  token: string = '';
  messaging: any;
  // topic = 'notification';
  firebaseApp: any = undefined;
  isSafari: boolean = false;

  constructor(private requestService: RequestService, private notificationService: NotificationService, private translate: TranslateService, private layoutUtilsService: LayoutUtilsService) {
    navigator.serviceWorker.addEventListener('message', event => {
      // console.log('event', event)
      if (!event.data?.shelter) {
        this.currentMessage.next(event.data);
        this.notificationService.showNotificationUnRead.next(true);
      }
      else
        this.notificationService.showShelterNotification.next(event.data.data);
    });

    if (Notification.permission === 'granted') {
      // try to subscribe
      // console.error('The user has blocked notifications.');
    } else if (Notification.permission === 'denied') {
      this.layoutUtilsService.showNotification(this.translate.instant('Notifications were blocked by the browser. Enable to receive notifications.'), this.translate.instant('Dismiss'));
      // console.error('The user has blocked notifications.');
    } else {
      // The user has not yet responded to the permission request
    }
  }
  public async initialize() {
    if (await isSupported()) {
      if (!getApps().length) {
        this.firebaseApp = initializeApp(environment.firebaseConfig);
      } else {
        this.firebaseApp = getApps()[0];
      }

      this.messaging = getMessaging(this.firebaseApp);

      onMessage(this.messaging, (payload) => {
        // console.log('Foreground message received:', payload);
        this.currentMessage.next(payload);
      });
    }
  }
  public async initializeOld() {
    if (await isSupported()) {
      try {
        // if (this.deviceService.browser.toLowerCase().indexOf('safari') != -1)
        // this.firebaseApp = initializeApp(environment.firebaseConfig, 'wrna');
        // else
        this.firebaseApp = initializeApp(environment.firebaseConfig);

        const messaging = getMessaging();
        onMessage(messaging, (payload) => {
          // console.log('Message received. ', payload);
          this.currentMessage.next(payload);
          // Update the UI to include the received message.

        });
      }
      catch (e) { }
      // this.requestPermission();
      // this.listen(this.firebaseApp);
    }
  }
  async registerMessagingServiceWorker() {
    if ('serviceWorker' in navigator) {
      const reg = await navigator.serviceWorker.register('/firebase-messaging-sw.js', { scope: '/' });
      console.log('Service Worker registered:', reg);
    }
  }

  async unregisterServiceWorkers() {
    if ('serviceWorker' in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations();
      for (let reg of regs) {
        await reg.unregister();
      }
    }
  }

  public async registerDevice(currentUserId: string, callback?: any) {
    if (Notification.permission !== 'granted') {
      console.warn('Notification permission not granted');
      return;
    }
    // this.prepareServiceWorker();

    let registration: ServiceWorkerRegistration | null = null;

    // Check if the service worker is already registered
    const registrations = await navigator.serviceWorker.getRegistrations();
    registration = registrations.find(reg =>
      reg.active?.scriptURL.endsWith('firebase-messaging-sw.js')
    ) || null;

    // Register only if not registered yet
    if (!registration) {
      registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js', { scope: '/' });
      console.log('Service Worker registered with scope:', registration.scope);
    } else {
      console.log('Using existing Service Worker with scope:', registration.scope);
    }

    // 2. Wait for service worker to be ready:
    await navigator.serviceWorker.ready;

    if (currentUserId) {
      getToken(this.messaging,
        {
          vapidKey: environment.firebaseVapidKey,
          serviceWorkerRegistration: registration
        }).then(
          (currentToken) => {
            this.token = currentToken;
            this.requestService.postRequest({
              userId: currentUserId,
              type: "Web",
              deviceId: this.token
            }, 'notify/register', (data, error) => {
              if (callback)
                callback();
            });
          }).catch(e => console.log(e))
    }

  }

  sendNotificationToDevice(responderId: string, payload: any) {
    this.requestService.postRequest('notify/firebase/' + responderId + '/send', payload, (data, error) => {

    });
  }

  sendNotificationToType(type: string, payload: any) {
    this.requestService.postRequest('notify/firebase/' + type, payload, (data, error) => {

    });
  }
  subscribeTopic(topic: string, callback: any): Promise<void> {
    return new Promise((resolve, reject) => {
      if (this.token && topic)
        this.requestService.postRequest({
          deviceToken: this.token,
          topic: topic
        }, 'notify/subscribe/topic', (data, error) => {
          if (data)
            resolve(data);
          else if (error)
            reject(error);

          if (callback)
            callback();
        });
    });
  }
  unsubscribeTopic(topic: string, callback: any): Promise<void> {
    return new Promise((resolve, reject) => {
      if (this.token && topic)
        this.requestService.postRequest({
          deviceToken: this.token,
          topic: topic
        }, 'notify/unsubscribe/topic', (data, error) => {
          if (data)
            resolve(data);
          else if (error)
            reject(error);

          callback();
        });
    });
  }

  unregisterDevice(userId: string, deviceId: string, callback: any, notValidToken: boolean = false): Promise<void> {
    return new Promise((resolve, reject) => {
      deleteToken(this.messaging).then(() => {
        if (this.token && !notValidToken)
          this.requestService.postRequest({
            userId: userId,
            deviceId: deviceId,
            type: "Web"
          }, 'notify/device/delete', (data, error) => {
            if (data)
              resolve(data);
            else if (error)
              reject(error);
            callback();
          });
        else {
          resolve(undefined);
          callback();
        }
      })
    });
  }

  async logout(notValidToken: boolean = false) {
    // if (this.requestService.currentUser?.shelter) {
    if (this.token)
      this.unregisterDevice(this.requestService._currentUser._id, this.token, () => {
        this.requestService.logOutApi();
      }, notValidToken);
    else
      this.requestService.logOutApi();
    // }
    // else {
    // this.unsubscribeTopic(this.topic, () => {
    // this.requestService.logOutApi();
    // })
    // }
  }
}